module.exports = __webpack_public_path__ + "front/img/banner1.a2460d9b.png";